import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MembershipTierCardProps {
  name: string;
  price: string;
  description: string;
  features: string[];
  responsibilities: string[];
  isPopular?: boolean;
  onSelect: () => void;
}

const MembershipTierCard: React.FC<MembershipTierCardProps> = ({
  name,
  price,
  description,
  features,
  responsibilities,
  isPopular = false,
  onSelect,
}) => {
  return (
    <div
      className={`relative bg-card rounded-lg p-6 border transition-all duration-300 hover:shadow-lg ${
        isPopular ? 'border-accent shadow-md' : 'border-border'
      }`}
    >
      {isPopular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-accent text-accent-foreground px-4 py-1 rounded-full text-xs font-bold">
            Most Popular
          </span>
        </div>
      )}

      <div className="text-center mb-6">
        <h3 className="text-2xl font-headline font-bold text-foreground mb-2">{name}</h3>
        <div className="mb-3">
          <span className="text-4xl font-bold text-primary">{price}</span>
          {price !== 'Free' && <span className="text-muted-foreground">/month</span>}
        </div>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>

      <div className="mb-6">
        <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center">
          <Icon name="SparklesIcon" size={16} className="text-primary mr-2" />
          Benefits
        </h4>
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start space-x-2">
              <Icon name="CheckIcon" size={16} className="text-success flex-shrink-0 mt-0.5" />
              <span className="text-sm text-foreground">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mb-6">
        <h4 className="text-sm font-semibold text-foreground mb-3 flex items-center">
          <Icon name="HandRaisedIcon" size={16} className="text-secondary mr-2" />
          Responsibilities
        </h4>
        <ul className="space-y-2">
          {responsibilities.map((responsibility, index) => (
            <li key={index} className="flex items-start space-x-2">
              <Icon
                name="ArrowRightIcon"
                size={16}
                className="text-muted-foreground flex-shrink-0 mt-0.5"
              />
              <span className="text-sm text-muted-foreground">{responsibility}</span>
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={onSelect}
        className={`w-full px-6 py-3 rounded-md font-cta text-sm font-bold transition-all duration-300 hover:shadow-md ${
          isPopular
            ? 'bg-accent text-accent-foreground hover:bg-accent/90'
            : 'bg-primary text-primary-foreground hover:bg-primary/90'
        }`}
      >
        Choose {name}
      </button>
    </div>
  );
};

export default MembershipTierCard;